<template>
  <div>
    <BaseLoader v-if="loading.contrats || loading.resumeGlobalContrats" />
    <div v-if="!loading.contrats && !loading.resumeGlobalContrats && contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix && Object.keys(contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix).length > 0">
      <div
        v-if="contratResumeGraineSelected"
        class="d-flex justify-space-around"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
      >
        <BasePieChart
          class="align-self-center mt-4"
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
          :chart-data="contratResumeGraineSelected.chartData"
        />
        <div
          class="align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'my-4' : ''"
        >
          <div
            v-for="(contenuContratResume, index) in Object.entries(contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix)"
            :key="index"
          >   
            <div class="pt-2 texte texte-gris-fonce">
              <v-chip
                label
                class="eq-width"
                :color="getColorChipLegende(contenuContratResume[0])"                                                    
              >
                <span
                  class="white--text"
                >
                  {{ buildContenuChipLegende(contenuContratResume) | roundNumber(0) }}  {{ uniteLegende(contenuContratResume) }}
                </span>
              </v-chip>
              <span :class="(isPrixEnCoursConstruction(contenuContratResume) && !isContratPaye(contenuContratResume)) ? '' : 'pt-2'">
                {{ contenuContratResume[0] }} 
              </span>
              <span>
                {{ buildComplementLibelleLegende(contenuContratResume) }}
              </span>
            </div>
          </div>
        </div>    
      </div>        
      <v-divider class="mb-2 mt-6" />      
      <div
        v-if="hasPrixMoyen"
        class="d-flex py-2"
      >
        <div
          class="equalHW flex-shrink-1 titre-h4 secondary--text"          
        >
          {{ buildLibellePrixMoyenGlobal }}
        </div>
        <div class="equalHW flex-shrink-1 chiffre secondary--text align-end">
          {{ contratsResumeGlobal.prixBaseMoyenGlobalNEnEuro | roundNumber(0) }} €/t
        </div>
      </div>  
      <div class="d-flex flex-row mt-1 mb-5">
        <div
          v-if="contratsResumeGlobal.dateDernierContrat"
          class="d-flex equalHW"
        >
          <div class="d-flex flex-column">
            <v-icon class="mr-2">
              mdi-calendar-refresh
            </v-icon>
          </div>
          <div class="d-flex flex-column texte texte-gris-fonce ">          
            Dernier contrat le {{ getDateFormatted(contratsResumeGlobal.dateDernierContrat) }}
          </div>
        </div>        
        <div class="d-flex flex-column justify-end equalHW align-end">
          <BaseEvolution
            v-if="contratsResumeGlobal.evolution && contratsResumeGlobal.evolution !== 0"
            :evolution-value="contratsResumeGlobal.evolution"
          />
        </div>
      </div>
    </div>
    <div
      v-if="!loading.contrats && !loading.resumeGlobalContrats && contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix && Object.keys(contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix).length === 0"
    >
      <div
        class="d-flex
        align-center
        flex-column"
        :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
      >
        <img
          src="@/assets/no-contrats.svg"
          alt="no-contrats"
        >
        <div
          class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2"
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
        >
          <span>Retrouvez les détails de chaque contrat</span>
          <span>(dates, poids, prix, lieu de livraison)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import BasePieChart from '@/components/chart/base-pie-chart.vue'
import numberFilter from '@/filters/number.filter'
import format from 'date-fns/format'
import BaseEvolution from '@/components/common/base-evolution.vue'
import {sommeDesNombresDefinis} from '@/utils/math'
import {clone} from '@/utils/clone'
import {isBefore} from 'date-fns'

export default {
  name: 'RepartitionContrats',
  components: { BaseLoader, BasePieChart, BaseEvolution },
  props: {    
    isUtilisateurAgrial: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {    
      loading: {
        contrats: false,
        resumeGlobalContrats: true
      },
      erreur: {
        contrats: false
      },
      listeCategoriesProvisoire: ['Prix campagne', 'Contrat filière', 'Prix par période'],
      listeCategoriesAvecPrixAffiche: ['Prix ferme', 'Contrat filière', 'Prix par période'],
      contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix: [],
      categoriesContratsModifiables: null
    }
  },

  computed: {
    ...mapGetters({
      categoriesContrats: 'application/categoriesContrats',
      contratResumeRs3AnneeRecolteEnCoursByTypePrix: 'contrat/contratResumeRs3AnneeRecolteEnCoursByTypePrix',
      contratsResumeGlobal: 'contrat/contratsResumeGlobal',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),
    contratResumeGraineSelected () {
      return this.contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix ? this.getContratAnneeRecolteEnCoursResume() : null
    },
    libelleGraineMessage () {
      const graineCommenceParUneVoyelle = this.graineSelected.libelle ? 'aeiouyAEIOUY'.indexOf(this.graineSelected.libelle.substring(0, 1)) !== -1 : 'de'
      const preposition = graineCommenceParUneVoyelle === true ? 'd\'' : 'de '
      return preposition + this.graineSelected.libelle
    },
    buildLibellePrixMoyenGlobal () {
      let provisoire = false        
      Object.entries(this.contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix).forEach((c) => {        
        this.listeCategoriesProvisoire.forEach((t) => {
          if (c[0] === t && !c[1].contrats.map(contrat => contrat.etatPaiement).some(etatPaiement => etatPaiement === 'payé')) {            
            provisoire = true
           }        
        })
      })    
      return 'Prix de base moyen' + (provisoire ? ' (provisoire)' : '')
    },
    hasPrixMoyen () {      
      return this.contratsResumeGlobal.prixBaseMoyenGlobalNEnEuro && this.contratsResumeGlobal.prixBaseMoyenGlobalNEnEuro !== 0
    }
  },

  watch: {   
    anneeRecolteActive () {
      this.loadContrats()
    },
    codeGraineActive: {
      handler () {
        if (this.codeGraineActive != null) {
          this.loadContrats()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      fetchContratResume: 'contrat/fetchContratResumeRs3AnneeRecolteEnCoursByTypePrix',
      fetchContratResumeGlobal: 'contrat/fetchContratsResumeGlobalRs3AnneeRecolte',
      getNbNouveauxContrats: 'contrat/getNbNouveauxContrats'
    }),
    loadContrats () {
      this.loading.contrats = true
      this.loading.resumeGlobalContrats = true
      this.erreur.contrats = false
      this.fetchContratResume()
        .then(() => {
          this.fetchContratResumeGlobal()
            .then(() => {
              this.categoriesContratsModifiables = clone(this.categoriesContrats)
              this.contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix = this.buildContratsParCategorie(this.contratResumeRs3AnneeRecolteEnCoursByTypePrix)
              this.getNewContratConsultation()
            })
            .finally(() => {this.loading.resumeGlobalContrats = false})
        })
        .catch(() => {
          this.erreur.contrats = true
        })
        .finally(() => {
          this.loading.contrats = false
        })
    },
    getNewContratConsultation () {
      if (window.PROPERTIES.has('GOOGLE_ANALYTICS_ID') && !this.isUtilisateurAgrial) {
        let contratNotConsulted = 0
        let listeDatesSouscriptionContrats = Object.values(this.contratResumeRs3AnneeRecolteEnCoursByTypePrix)
          .flatMap(a => a.contrats
            .map(element => element.dateSouscription))
        let lastConsultation = this.$cookies.get('LAST_CONSULTATION_DETAIL_CONTRAT_' + this.anneeRecolteActive + '_' + this.codeGraineActive)
        for (var i = 0; i < listeDatesSouscriptionContrats.length; i++) {
          let dateSouscription = listeDatesSouscriptionContrats[i] !== undefined ? listeDatesSouscriptionContrats[i] : null
          if (lastConsultation != null && dateSouscription != null) {
            if (isBefore(new Date(lastConsultation).getTime(), new Date(dateSouscription).getTime()) || (new Date(lastConsultation).getTime() === new Date(dateSouscription).getTime())) {
              contratNotConsulted++
            }
          }
          this.getNbNouveauxContrats(contratNotConsulted)
        }
      } else {
        this.getNbNouveauxContrats(0)
      }
    },
    getColors (libellesTypeContrats) {
      if (this.categoriesContratsModifiables) {
        let results = []
        libellesTypeContrats.forEach((libelle) => {
          this.categoriesContratsModifiables.forEach((t) => {
            if (libelle === t.libelle) {
              results.push(t.color)
            }
          })
        })
        return results
      }
      return null
    },
    getContratAnneeRecolteEnCoursResume () {
      const resumebyGraine = Object.values(this.contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix)
      const quantiteTotale = numberFilter.formatNumber(resumebyGraine.flatMap(a => a.contrats
        .map(element => element.quantiteCibleEnKg)
        .reduce((a, b) => a + b, 0))
        .reduce((a, b) => a + b, 0), 0, 0.001)
      const nbContrats = this.getNbContrats(resumebyGraine)
     
      const contratsResumeData = {
          quantiteTotale,
          txtQuantiteTotal: quantiteTotale + ' t',
          nbContrats,
          txtNbContrats: `${nbContrats} contrat${nbContrats > 1 ? 's' : ''} `,
          chartData: this.chartData(this.contratResumeRs3AnneeRecolteEnCoursReconstruitByTypePrix)
      }     
      return contratsResumeData
    },
    getNbContrats (resume) {       
      return resume.map(a => a.contrats.length).reduce((a, b) => a + b, 0)
    },
    getQuantiteTresoMoissonAFixer (contratTresoMoissonAFixer) {      
      return Number(sommeDesNombresDefinis(
       contratTresoMoissonAFixer.quantiteTresoMoissonLivreeSansFixationEnKg,
        + contratTresoMoissonAFixer.quantiteTresoMoissonEngageAFixerEnKg,
        - contratTresoMoissonAFixer.quantiteTresoMoissonEnAttenteEnKg))
    },
    buildContratsParCategorie (resumeRs3ByTypePrix) {
      if (resumeRs3ByTypePrix != null) {
        // Cas spécifique tréso moisson à fixer qui sont dans la catégorie Prix ferme => on les sort pour les mettre dans la catégorie Tréso moisson à fixer
        const listeContratsTresoMoissonAFixer = []
        const listeContratsPrixFerme = []
        let contrats = clone(resumeRs3ByTypePrix)
        Object.values(contrats).map(r => r.contrats).forEach((c) => {
          for (let i = 0; i < c.length; i++) { 
            if (c[i].type.categorieContrat === 'Prix ferme') {         
              if (c[i].type.code === 'TRESO_MOISSON_A_FIXER') {
                c[i].type.categorieContrat = 'Tréso moisson à fixer'
                listeContratsTresoMoissonAFixer.push(c[i])
                c.splice(i,1)
              } else {
                listeContratsPrixFerme.push(c[i])
              }
            }
          }
        })
        
        if (listeContratsTresoMoissonAFixer.length > 0) {
          // Verif que le tonnage à fixer différent de 0 si oui on sort les contrats tréso moisson à fixer des contrats prix ferme
          let tonnageAFixer = 0
          listeContratsTresoMoissonAFixer.forEach((contrat) => {
            tonnageAFixer = tonnageAFixer + this.getQuantiteTresoMoissonAFixer(contrat)
          })
          if (numberFilter.formatNumber(tonnageAFixer, 0, 0.001) > 0) {
            this.categoriesContratsModifiables.push({code:'TRESO_MOISSON_A_FIXER', libelle:'Tréso moisson à fixer', color : '#E4E5D2'})
            Object.assign(contrats, {'Tréso moisson à fixer': {contrats: listeContratsTresoMoissonAFixer}})
          }
        }

        // Si pas d'autre contrat Prix ferme que les Tréso moisson à fxer => retrait de la catégorie Prix ferme
        if (listeContratsPrixFerme.length === 0) {                    
          delete contrats['Prix ferme']
        }
        return contrats
      }
      return null

    },
    chartData (contrats) {
      if (contrats != null) {        
        
        let labels = Object.keys(contrats)        
        let data = Object.values(contrats).map(a => {
          const isContratTresoMoissonAFixer = a.contrats.findIndex(contrat => contrat.type.code === 'TRESO_MOISSON_A_FIXER') >= 0          
          let quantiteContratsenKg = 0
          if (isContratTresoMoissonAFixer) {
            quantiteContratsenKg = a.contrats
            .map(element => this.getQuantiteTresoMoissonAFixer(element))
            .reduce((a, b) => a + b, 0)
          } else {
            quantiteContratsenKg = a.contrats
            .map(element => element.quantiteCibleEnKg)
            .reduce((a, b) => a + b, 0)
          }
          return numberFilter.formatNumber(quantiteContratsenKg, 0, 0.001)
        })
        const length = Object.keys(contrats).length
        let legend = []
        for (let i = 0; i < length; i++) {
          legend.push(labels[i])
        }
        const nbContrats = Object.values(contrats).map(a => a.contrats.length)         
        return {
          id:' chartContrats',
          labels: legend,
          title: '',
          datasets: [
            {
              backgroundColor: this.getColors(labels),
              data: data,
              legendTooltip: { title: 'tonnage', value: data, unit: 't' },
              legendTooltipSup: { title: 'quantité', value: nbContrats, unit: 'contrat(s)' },
              label: labels,
              unite: 't'
            }
          ]
        }
      }
      return null
    },     
    buildContenuChipLegende (contenuContratResume) {
       return this.isPrixAffiche(contenuContratResume) ? this.isPrixEnCoursConstruction(contenuContratResume) ? contenuContratResume[1].prixBaseMoyenGestionDelegueeEnEuro : contenuContratResume[1].prixBaseMoyenEnEuro
      : ''

    },
    uniteLegende (contenuContratResume) {
      return this.isPrixAffiche(contenuContratResume) && this.buildContenuChipLegende(contenuContratResume) > 0 ? '€/t' : ''
    },
    isPrixEnCoursConstruction (contenuContratResume) {            
      return this.listeCategoriesProvisoire.includes(contenuContratResume[0])
    },
    isPrixAffiche (contenuContratResume) {
      return this.listeCategoriesAvecPrixAffiche.includes(contenuContratResume[0]) || contenuContratResume[1].contrats.map(c => c.type.categorieContrat).includes('Prix campagne')
    },
    isContratPaye (contenuContratResume) {
      return contenuContratResume[1].contrats.map(contrat => contrat.etatPaiement).some(etatPaiement => etatPaiement === 'payé')
    },
    buildComplementLibelleLegende (contenuContratResume) {
      return (this.isPrixEnCoursConstruction(contenuContratResume) && !this.isContratPaye(contenuContratResume) && this.buildContenuChipLegende(contenuContratResume) > 0) ? ' (provisoire)' : ''      
    },
    getColorChipLegende (libelleTypeContrat) {      
      let color = ''
      if (this.categoriesContratsModifiables) {        
        this.categoriesContratsModifiables.forEach((t) => {
          if (libelleTypeContrat === t.libelle) {
            color = t.color
          }
        })          
      }
      return color      
    },
     getDateFormatted (value) {
      return value ? format(new Date(value), 'dd/MM/yyyy') : 'XX/XX/XXXX'
    }
  }
}
</script>

<style scoped lang="scss">

.eq-width {
  width: 70px;
}

.equalHW {
	flex: 1;
}

.align-end {
  text-align: end;
}

.text-align-center {
  text-align: center;
}
</style>
